import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=7cd366e6&scoped=true&"
import script from "./DocumentsTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=7cd366e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd366e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VSimpleTable,VTooltip})
